import PromoteurList from '@/components/promoteur/PromoteurList'
import PromoteurEdit from '@/components/promoteur/PromoteurEdit'
import PromoteurVue from '@/components/promoteur/PromoteurVue'
import PromoteurCreate from '@/components/promoteur/PromoteurCreate'

export default [
  {
    path: '/promoteurs',
    name: 'PromoteurList',
    component: PromoteurList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/promoteurs/:id/edition',
    name: 'PromoteurEdit',
    component: PromoteurEdit,
    meta: {
      parentName: 'PromoteurVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/promoteurs/creation',
    name: 'PromoteurCreate',
    component: PromoteurCreate,
    meta: {
      parentName: 'PromoteurList',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/promoteurs/:id',
    name: 'PromoteurVue',
    component: PromoteurVue,
    meta: {
      parentName: 'PromoteurList',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/promoteurRouter.js